import { WorkloadMemberEntity } from './workload-member.entity';

export class TeamWorkloadEntity {
  public teamId!: string;
  public teamName!: string;
  public managedBy!: string[];
  public overCapacityCount!: number;
  public overdueCount!: number;
  public onTimeOffCount!: number;
  public totalMembers!: number;
  public members!: WorkloadMemberEntity[];
}
